export enum SortTypeEnum {
    Price = 'price',
    Rating = 'rating',
    Discount = 'discount',
    DistanceFromCenter = 'distanceFromCenter',
    DistanceFromBeach = 'distanceFromBeach',
}

export enum SortApiMapping {
    PriceAsc = 'priceAsc',
    PriceDesc = 'priceDesc',
    RatingDesc = 'ratingDesc',
    DiscountDesc = 'discountDesc',
    DistanceFromCenterAsc = 'distanceFromCenterAsc',
    DistanceFromBeachAsc = 'distanceFromBeachAsc',
}

export enum LegacySortApiMapping {
    PriceAsc = 'cena_rosnaco',
    PriceDesc = 'cena_malejaco',
    RatingDesc = 'reviews_amount_desc',
    DiscountDesc = 'discount_desc',
    DistanceFromCenterAsc = 'distance_from_center_asc',
    DistanceFromBeachAsc = 'distance_from_beach_asc',
}
